<template>
<div :style="{ backgroundColor: backgroundcolor }" id="wrapper">
  <div id="logo_chat_nuevo">
     <div id="logo_chat">
         <img style="margin: 10px" src="https://imagenes.leon.gob.mx/logo-leon.svg" width="150px" >
     </div>
       <div id="logo_leon">
          <img style="margin: 10px" src="img/logoatencion.png" width="100px" >
     </div>
  </div>

  <div>
    
    <!-- chat de operador -->
     <span id="info" style="background-color:#163A63;">{{userName}}</span>
    <span id="info" style="background-color:#006E67;">{{userEmail}}</span>
     <div id="chat" style="overflow-y: auto; overflow-x:hidden; width: auto; height: 350px; margin:10px; border:1px solid #e7e5e5;">
        <div class="row" style="margin-left:10px; text-align:left; margin-top:5px"
              v-for="message in this.chatMessages.slice().reverse()" :key="message.key">
        <div v-if="message.details.type=='op'">
          <div class="alert alert-primary" role="alert">
            <span class=""><i class="fa fa-user-tie" style="color:#2C4DB8;"></i></span>
            <strong> Tú : </strong>{{message.details.mensaje}}
          </div>
        </div>
        <div v-if="message.details.type=='us'">
          <div class="alert alert-warning" role="alert">
              <span class=""><i class="fa fa-user" style="color:#b39226 "></i></span>
            <strong> {{userName}} : </strong> {{message.details.mensaje}}
          </div>
        </div>
        </div>
    </div>

    <div class="row row justify-content-center" >
      <div class="col-11 ">
        <div class="input-group">
           <div class="input-group-prepend">
            <span class="input-group-text bg-white  border-right-0"><i class="fa fa-user" style="color:#000;"></i></span>
          </div>
          <input id="inputOpMsg"  autocomplete="off" type="text" class="form-control border-left-0 control" placeholder="Escribe tu mensaje" v-model="mensaje" v-on:keyup.13="sendMessOperator">
          <div class="input-group-append">
            <button v-on:click="sendMessOperator" class="btn btn-warning" style="background-color:#006E67;border-color:#006E67;" >Enviar</button>
             <button v-on:click="confirmEndChat" class="btn btn-danger" style="background-color:#f6A800;border-color:#f6A800;">Terminar</button>
              <button v-on:click="banningUser" class="btn btn-primary" style="background-color:#522360;border-color:#522360;">Bloquear</button>
          </div>
        </div><br/>
        <div class="mb-3">
           <div class="input-group">
             <div class="input-group-prepend">
            <span class="input-group-text bg-white  border-right-0"><i class="fa fa-align-justify" style="color:#000;"></i></span>
          </div>
            <select  id="mensajes" v-model="mensajesDefault" v-on:change="onChangeOperatorMsg" class="form-control control">
              <option value="0" selected>Selecciona un mensaje definido </option>
              <option v-for="message in this.defaults" :key="message" >{{message}}</option>
            </select>
           </div>
        </div>
      </div>
       </div>
  </div>
</div>
</template>

<script>
import firebase from "firebase";

/* Chat de operador*/
export default {
  name: "Chat",
  props: {
    msg: String
  },
  data() {
    return {
      name: null,
      userEmail: null,
      userName: null,
      mensaje: null,
      operator: null,
      messages: null,
      opsess: null,
      ready: null,
      origen:null,
      backgroundcolor: "#EEEEED",
      mensajesDefault: null
    };
  },
  methods: {
    beforeDestroy:function(){
      console.log("d")
      vm.$destroy()
    },
    bottomChatWindow:function(){
      var container = this.$el.querySelector("#chat");
      container.scrollTop = container.scrollHeight;
    },
    startIntervalChatWindowBottom:function(){
      var self = this;
      setInterval(()=>{
        self.bottomChatWindow();
      },1000)
    },
    isAuth: function() {
      firebase.auth().onAuthStateChanged(function(user) {
        // if (user) {
        //   console.log(user)
        // } else {
        // }
      });
    },
    getDefaultMessages() {
      return firebase
        .database()
        .ref(`mensajes/`)
        .once("value");
    },
    sendMessOperator() {
       if(this.mensaje!=""){
          firebase
            .database()
            .ref(`chats/current/${this.$route.params.keyId}`)
            .push({
              type: "op",
              mensaje: this.mensaje,
              date: Date.now()
            });
          this.mensaje = "";
       }
    },
    onChangeOperatorMsg() {
      this.mensaje = this.mensajesDefault == "0" ? "" : this.mensajesDefault;
      this.mensajesDefault = 0;
    },
    operatorTakeUser(user) {
      let self = this
      /* El operador tomo el chat, cambia status en lobby*/
      if(self.$route.params.keyId!=undefined || self.$route.params.keyId!=null){
      firebase
        .database()
        .ref(`lobby/users/${self.$route.params.keyId}`)
        .update({
          status: "1",
          operatorId: user.email,
          Iniciado: Date.now(),
        });
      }
    },
    /* Si el ciudadano terminó la conversación */
    onListenChangesLobby() {
      console.log("operador escuchando de ciudadano")
      var self = this;
       if(self.$route.params.keyId!=undefined || self.$route.params.keyId!=null){
      var ref = firebase
        .database()
        .ref(`lobby/users/${self.$route.params.keyId}`);
      ref.on("value", function(snapshot) {
        if (snapshot.val() != null && parseInt(snapshot.val().status) == 2) {
          self.OperatorEndsChat();
        }
      });
       }
    },
    onReceiveMessage() {
      var self = this;
       if(self.$route.params.keyId!=undefined || self.$route.params.keyId!=null){
          var ref = firebase
        .database()
        .ref(`chats/current/${this.$route.params.keyId}`);
        ref.on("value", function(snapshot) {
           self.messages = [];
           setTimeout(self.bottomChatWindow,1000)
        snapshot.forEach(element => {
          self.messages.push({
            details: element.val()
          });
        });
      });
     }      
    },
    
    
    confirmEndChat(){
      this.OperatorEndsChat();
    },

    banningUser(){
      var confirmEnd =  confirm("¿ Deseas bloquear la ip del ciudadano ?");
      if(confirmEnd){
        this.addUserToBlackList();
      }
    },

    addUserToBlackList(){
      firebase.database().ref(`blacklist/`).push({
         ip: this.ipAddress,
         fecha: Date.now()
      });
      this.OperatorEndsChat();
    },
    OperatorEndsChat() {
      /* Operador Termina la conversacion  */
      /* Detecta cambios en el chat actual y en lobby*/
      var self = this;
      console.log("operador teminando ...")
      this.onListenChangesLobby = null;
      let sessionId = this.$route.params.keyId
      firebase.database().ref(`lobby/users/${sessionId}`).update({
           status: "2"
        }, function(error) {
          if (error) {
                  console.log(error)

        } else {
            firebase.database().ref(`lobby/users/${sessionId}`).remove();
            firebase.database().ref(`chats/current/${sessionId}`).remove();
            localStorage.sesionID = null;
            localStorage.removeItem("sesionID");
            // self.$router.push({
            //   name: "Lobby"
            // });

            self.$router.back();
        }
      });

      /*firebase
        .database()
        .ref(`lobby/users/${this.$route.params.keyId}`)
        .remove();*/

      /* Redirecciona al Lobby */
      // setTimeout(()=>{
      //   self.deleteLobby(),5000
      // })

    },


    deleteLobby(){
      firebase
        .database()
        .ref(`lobby/users/${sessionId}`)
        .remove();
        this.$router.push({
        name: "Lobby"
      });
    },

    onOperatorCloseBrowserInChat() {
      /* reinicia */
      if (this.$route.params.keyId != undefined) {
        firebase
          .database()
          .ref(`users/online/${this.ops}`)
          .remove();
        firebase
          .database()
          .ref(`lobby/users/${this.$route.params.keyId}`)
          .update({ status: "3" });
        localStorage.LEO_REI = 1;
      }
      //localStorage.removeItem('opSess');
    }
  },

  created() {
    let self = this;
    //this.startIntervalChatWindowBottom();
    this.messages = [];
    this.defaults = [];
    this.getDefaultMessages().then(snapshot => {
      snapshot.forEach(e => {
        self.defaults.push(e.val());
      });
    });
    firebase.auth().onAuthStateChanged(user => {
      if (user) {

        firebase
          .database()
          .ref(`lobby/users/${this.$route.params.keyId}`)
          .once("value")
          .then(snapshot => {
            self.userEmail = snapshot.val().email;
            self.userName = snapshot.val().username;
          });
        this.ops = this.$route.params.opsess;
        this.ipAddress = this.$route.params.ipAddress
        this.operatorTakeUser(user);

        /* crea nueva sesion - ojo, no publico*/
        if (
          localStorage.LEO_REI != undefined &&
          localStorage.opSess != undefined
        ) {
          firebase
            .database()
            .ref(`users/online/`)
            .push({
              loggIn: true
            })
            .then(sessionId => {
              firebase
                .database()
                .ref(`lobby/users/${this.$route.params.keyId}`)
                .update({ status: "1",  Iniciado: Date.now() });
              self.ops = sessionId.key;
              localStorage.opSess = sessionId.key;
              localStorage.removeItem("LEO_REI");
            });
        }

        /* Listeners */
        window.addEventListener(
          "beforeunload",
          this.onOperatorCloseBrowserInChat
        );
        this.onListenChangesLobby();
        this.onReceiveMessage();
      } else {
        self.$router.push({ name: "Acceso" });
      }
    });
  },
  computed: {
    chatMessages: function() {
      return this.messages.reverse();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#info{
   margin-right: 5px;
   font-family: 'Noto Sans JP', sans-serif;
   font-size: 14px;
   padding: 10px;
   border-radius: 7px;
   color: white;
   display: inline-block;
}

#logo_leon{
  flex-direction: column;
}
#logo_chat{
    flex-direction: column;

}
#logo_chat_nuevo{
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   padding-left: 20px;
   padding-right: 20px;
}
#wrapper {
  margin: 0;
  padding: 0px 10px;
  background-color: blueviolet;
  width: 100%;
}


#chat{
   font-family: 'Noto Sans JP', sans-serif;
   font-size: 13px;
   background-color: white;

}
button{
  font-family: 'Noto Sans JP', sans-serif;
   font-size: 13px;
    color: white;
}
.control{
   font-family: 'Noto Sans JP', sans-serif;
    font-size: 13.5px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}
input {
 outline:none;
}
</style>
